/**
 * ESPN internal NCAA school IDs for basketball (men's and women's programs
 * typically share the same athletics logo on a.espncdn.com).
 * URL: https://a.espncdn.com/i/teamlogos/ncaa/500/{id}.png
 */
export const NCAAB_ESPN_TEAM_IDS = {
  "Abilene Christian Wildcats": 2000,
  "Air Force Falcons": 2005,
  "Akron Zips": 2006,
  "Alabama Crimson Tide": 333,
  "Alabama State Hornets": 2011,
  "Alcorn State Braves": 2016,
  "American Eagles": 44,
  "App State Mountaineers": 2026,
  "Appalachian State Mountaineers": 2026,
  "Arizona State Sun Devils": 9,
  "Arizona Wildcats": 12,
  "Arkansas Razorbacks": 8,
  "Arkansas State Red Wolves": 2032,
  "Army Black Knights": 349,
  "Auburn Tigers": 2,
  "Austin Peay Governors": 2046,
  "Ball State Cardinals": 2050,
  "Baylor Bears": 239,
  "Belmont Bruins": 2057,
  "Binghamton Bearcats": 2066,
  "Boise State Broncos": 68,
  "Boston College Eagles": 103,
  "Boston University Terriers": 104,
  "Bowling Green Falcons": 189,
  "Bradley Braves": 71,
  "Brown Bears": 225,
  "Bryant Bulldogs": 2803,
  "Bucknell Bison": 2083,
  "Buffalo Bulls": 2084,
  "Butler Bulldogs": 2086,
  "BYU Cougars": 252,
  "Cal Poly Mustangs": 13,
  "Cal State Bakersfield Roadrunners": 2934,
  "Cal State Fullerton Titans": 2239,
  "Cal State Northridge Matadors": 2463,
  "California Baptist Lancers": 2856,
  "California Golden Bears": 25,
  "Campbell Fighting Camels": 2097,
  "Canisius Golden Griffins": 2099,
  "Central Arkansas Bears": 2110,
  "Central Connecticut Blue Devils": 2115,
  "Central Michigan Chippewas": 2117,
  "Charleston Cougars": 232,
  "Charleston Southern Buccaneers": 2127,
  "Charlotte 49ers": 2429,
  "Chattanooga Mocs": 236,
  "Chicago State Cougars": 2130,
  "Cincinnati Bearcats": 2132,
  "Clemson Tigers": 228,
  "Cleveland State Vikings": 325,
  "Coastal Carolina Chanticleers": 324,
  "Colgate Raiders": 2142,
  "Colorado Buffaloes": 38,
  "Colorado State Rams": 36,
  "Columbia Lions": 171,
  "Coppin State Eagles": 2145,
  "Cornell Big Red": 172,
  "Creighton Bluejays": 156,
  "Dartmouth Big Green": 159,
  "Davidson Wildcats": 2166,
  "Dayton Flyers": 2168,
  "DePaul Blue Demons": 305,
  "Detroit Mercy Titans": 2174,
  "Drake Bulldogs": 2181,
  "Drexel Dragons": 2182,
  "Duke Blue Devils": 150,
  "Duquesne Dukes": 2184,
  "East Carolina Pirates": 151,
  "East Tennessee State Buccaneers": 2193,
  "Eastern Illinois Panthers": 2197,
  "Eastern Kentucky Colonels": 2198,
  "Eastern Michigan Eagles": 2199,
  "Eastern Washington Eagles": 331,
  "Elon Phoenix": 2210,
  "Evansville Purple Aces": 339,
  "Fairfield Stags": 2215,
  "Fairleigh Dickinson Knights": 161,
  "Florida A&M Rattlers": 50,
  "Florida Atlantic Owls": 2226,
  "Florida Gators": 57,
  "Florida Gulf Coast Eagles": 526,
  "Florida International Panthers": 2229,
  "Florida State Seminoles": 52,
  "Fordham Rams": 2230,
  "Fort Wayne Mastodons": 3097,
  "Fresno State Bulldogs": 278,
  "Furman Paladins": 231,
  "Gardner-Webb Runnin' Bulldogs": 2241,
  "George Mason Patriots": 2244,
  "George Washington Revolutionaries": 45,
  "Georgetown Hoyas": 46,
  "Georgia Bulldogs": 61,
  "Georgia Southern Eagles": 290,
  "Georgia State Panthers": 2247,
  "Georgia Tech Yellow Jackets": 59,
  "Gonzaga Bulldogs": 2250,
  "Grambling Tigers": 2755,
  "Grand Canyon Lopes": 2253,
  "Green Bay Phoenix": 2739,
  "Hampton Pirates": 2261,
  "Harvard Crimson": 108,
  "Hawaii Rainbow Warriors": 62,
  "High Point Panthers": 2272,
  "Hofstra Pride": 2275,
  "Holy Cross Crusaders": 107,
  "Houston Cougars": 248,
  "Howard Bison": 47,
  "Idaho State Bengals": 304,
  "Idaho Vandals": 70,
  "Illinois Fighting Illini": 356,
  "Illinois State Redbirds": 2287,
  "Incarnate Word Cardinals": 2916,
  "Indiana Hoosiers": 84,
  "Indiana State Sycamores": 282,
  "Iona Gaels": 314,
  "Iowa Hawkeyes": 2294,
  "Iowa State Cyclones": 66,
  "Jackson State Tigers": 2296,
  "Jacksonville Dolphins": 294,
  "Jacksonville State Gamecocks": 55,
  "James Madison Dukes": 256,
  "Kansas City Roos": 140,
  "Kansas Jayhawks": 2305,
  "Kansas State Wildcats": 2306,
  "Kennesaw State Owls": 338,
  "Kent State Golden Flashes": 2309,
  "Kentucky Wildcats": 96,
  "La Salle Explorers": 2325,
  "Lafayette Leopards": 322,
  "Lamar Cardinals": 2320,
  "Lehigh Mountain Hawks": 2329,
  "Liberty Flames": 2335,
  "Lipscomb Bisons": 288,
  "Little Rock Trojans": 2031,
  "Long Beach State Beach": 299,
  "Long Island University Sharks": 112358,
  "Longwood Lancers": 2344,
  "Louisiana Ragin' Cajuns": 309,
  "Louisiana Tech Bulldogs": 2348,
  "Louisiana-Monroe Warhawks": 2433,
  "Louisville Cardinals": 97,
  "Loyola Chicago Ramblers": 2350,
  "Loyola Maryland Greyhounds": 2352,
  "Loyola Marymount Lions": 2351,
  "LSU Tigers": 99,
  "Maine Black Bears": 311,
  "Manhattan Jaspers": 2363,
  "Marist Red Foxes": 2368,
  "Marquette Golden Eagles": 269,
  "Marshall Thundering Herd": 276,
  "Maryland Eastern Shore Hawks": 2379,
  "Maryland Terrapins": 120,
  "McNeese Cowboys": 2377,
  "Memphis Tigers": 235,
  "Mercer Bears": 2382,
  "Mercyhurst Lakers": 2385,
  "Merrimack Warriors": 2771,
  "Miami Hurricanes": 1930,
  "Miami RedHawks": 193,
  "Michigan State Spartans": 127,
  "Michigan Wolverines": 130,
  "Middle Tennessee Blue Raiders": 2393,
  "Milwaukee Panthers": 270,
  "Minnesota Golden Gophers": 135,
  "Mississippi State Bulldogs": 344,
  "Mississippi Valley State Delta Devils": 2400,
  "Missouri State Bears": 2623,
  "Missouri Tigers": 142,
  "Monmouth Hawks": 2405,
  "Montana Grizzlies": 149,
  "Montana State Bobcats": 147,
  "Morehead State Eagles": 2413,
  "Morgan State Bears": 2415,
  "Mount St. Mary's Mountaineers": 116,
  "Murray State Racers": 93,
  "Navy Midshipmen": 2426,
  "NC State Wolfpack": 152,
  "North Carolina State Wolfpack": 152,
  "Nebraska Cornhuskers": 158,
  "Nevada Wolf Pack": 2440,
  "New Hampshire Wildcats": 160,
  "New Mexico Lobos": 167,
  "New Mexico State Aggies": 166,
  "New Orleans Privateers": 2443,
  "Niagara Purple Eagles": 315,
  "Nicholls Colonels": 2447,
  "Norfolk State Spartans": 2450,
  "North Alabama Lions": 2453,
  "North Carolina A&T Aggies": 2448,
  "North Carolina Central Eagles": 2428,
  "North Carolina Tar Heels": 153,
  "UNC Tar Heels": 153,
  "North Dakota Fighting Hawks": 155,
  "North Dakota State Bison": 2449,
  "North Florida Ospreys": 2454,
  "North Texas Mean Green": 249,
  "Northeastern Huskies": 111,
  "Northern Arizona Lumberjacks": 2464,
  "Northern Colorado Bears": 2458,
  "Northern Illinois Huskies": 2459,
  "Northern Iowa Panthers": 2460,
  "Northern Kentucky Norse": 94,
  "Northwestern Wildcats": 77,
  "Northwestern State Demons": 2466,
  "Notre Dame Fighting Irish": 87,
  "Oakland Golden Grizzlies": 2473,
  "Ohio Bobcats": 195,
  "Ohio State Buckeyes": 194,
  "Oklahoma Sooners": 201,
  "Oklahoma State Cowboys": 197,
  "Old Dominion Monarchs": 295,
  "Ole Miss Rebels": 145,
  "Mississippi Rebels": 145,
  "Omaha Mavericks": 2437,
  "Oral Roberts Golden Eagles": 198,
  "Oregon Ducks": 2483,
  "Oregon State Beavers": 204,
  "Pacific Tigers": 279,
  "Penn State Nittany Lions": 213,
  "Pennsylvania Quakers": 219,
  "Pepperdine Waves": 2492,
  "Pittsburgh Panthers": 221,
  "Portland Pilots": 2501,
  "Portland State Vikings": 2502,
  "Prairie View A&M Panthers": 2504,
  "Presbyterian Blue Hose": 2506,
  "Princeton Tigers": 163,
  "Providence Friars": 2507,
  "Purdue Boilermakers": 2509,
  "Purdue Fort Wayne Mastodons": 3097,
  "Queens University Royals": 2511,
  "Quinnipiac Bobcats": 2514,
  "Radford Highlanders": 2515,
  "Rhode Island Rams": 227,
  "Rice Owls": 242,
  "Richmond Spiders": 257,
  "Rider Broncs": 2520,
  "Robert Morris Colonials": 2523,
  "Rutgers Scarlet Knights": 164,
  "Sacramento State Hornets": 16,
  "Sacred Heart Pioneers": 2529,
  "Saint Joseph's Hawks": 2603,
  "Saint Louis Billikens": 139,
  "Saint Mary's Gaels": 2608,
  "Saint Peter's Peacocks": 2612,
  "Sam Houston Bearkats": 2534,
  "Samford Bulldogs": 2535,
  "San Diego State Aztecs": 21,
  "San Diego Toreros": 301,
  "San Francisco Dons": 2539,
  "San Jose State Spartans": 23,
  "Santa Clara Broncos": 2541,
  "Seattle U Redhawks": 2547,
  "Seton Hall Pirates": 2550,
  "Siena Saints": 2561,
  "SIU Edwardsville Cougars": 2565,
  "SMU Mustangs": 2567,
  "South Alabama Jaguars": 6,
  "South Carolina Gamecocks": 2579,
  "South Carolina State Bulldogs": 2569,
  "South Dakota Coyotes": 233,
  "South Dakota State Jackrabbits": 2571,
  "Southeast Missouri State Redhawks": 2546,
  "Southeastern Louisiana Lions": 2545,
  "Southern Illinois Salukis": 79,
  "Southern Indiana Screaming Eagles": 88,
  "Southern Jaguars": 2582,
  "Southern Miss Golden Eagles": 2572,
  "Southern Utah Thunderbirds": 253,
  "St. Bonaventure Bonnies": 179,
  "St. Francis (PA) Red Flash": 2598,
  "St. John's Red Storm": 2599,
  "St. Thomas (MN) Tommies": 2900,
  "Stanford Cardinal": 24,
  "Stephen F. Austin Lumberjacks": 2617,
  "Stetson Hatters": 56,
  "Stonehill Skyhawks": 284,
  "Stony Brook Seawolves": 2619,
  "Syracuse Orange": 183,
  "Tarleton State Texans": 2627,
  "TCU Horned Frogs": 2628,
  "Temple Owls": 218,
  "Tennessee State Tigers": 2634,
  "Tennessee Tech Golden Eagles": 2635,
  "Tennessee Volunteers": 2633,
  "Texas A&M Aggies": 245,
  "Texas A&M-Corpus Christi Islanders": 357,
  "Texas Longhorns": 251,
  "Texas Southern Tigers": 2640,
  "Texas State Bobcats": 326,
  "Texas Tech Red Raiders": 2641,
  "The Citadel Bulldogs": 2643,
  "Toledo Rockets": 2649,
  "Towson Tigers": 119,
  "Troy Trojans": 2653,
  "Tulane Green Wave": 2655,
  "Tulsa Golden Hurricane": 202,
  "UAB Blazers": 5,
  "UC Davis Aggies": 302,
  "UC Irvine Anteaters": 300,
  "UC Riverside Highlanders": 27,
  "UC San Diego Tritons": 28,
  "UC Santa Barbara Gauchos": 2540,
  "UCF Knights": 2116,
  "UCLA Bruins": 26,
  "UConn Huskies": 41,
  "Connecticut Huskies": 41,
  "UIC Flames": 82,
  "UMass Lowell River Hawks": 2349,
  "UMass Minutemen": 113,
  "Massachusetts Minutemen": 113,
  "UNC Asheville Bulldogs": 2427,
  "UNC Greensboro Spartans": 2430,
  "UNC Wilmington Seahawks": 350,
  "UNLV Runnin' Rebels": 2439,
  "USC Trojans": 30,
  "USC Upstate Spartans": 2908,
  "UT Arlington Mavericks": 250,
  "UT Martin Skyhawks": 2630,
  "UT Rio Grande Valley Vaqueros": 292,
  "UTEP Miners": 2638,
  "UTSA Roadrunners": 2636,
  "Utah State Aggies": 328,
  "Utah Tech Trailblazers": 3101,
  "Utah Utes": 254,
  "Utah Valley Wolverines": 3084,
  "Valparaiso Beacons": 2674,
  "Vanderbilt Commodores": 238,
  "VCU Rams": 2670,
  "Vermont Catamounts": 261,
  "Villanova Wildcats": 222,
  "Virginia Cavaliers": 258,
  "Virginia Tech Hokies": 259,
  "VMI Keydets": 2678,
  "Wagner Seahawks": 2681,
  "Wake Forest Demon Deacons": 154,
  "Washington Huskies": 264,
  "Washington State Cougars": 265,
  "Weber State Wildcats": 2692,
  "West Georgia Wolves": 2698,
  "West Virginia Mountaineers": 277,
  "Western Carolina Catamounts": 2717,
  "Western Illinois Leathernecks": 2710,
  "Western Kentucky Hilltoppers": 98,
  "Western Michigan Broncos": 2711,
  "Wichita State Shockers": 2724,
  "William & Mary Tribe": 2729,
  "Winthrop Eagles": 273,
  "Wisconsin Badgers": 275,
  "Wofford Terriers": 2747,
  "Wright State Raiders": 2750,
  "Wyoming Cowboys": 2751,
  "Xavier Musketeers": 2752,
  "Yale Bulldogs": 43,
  "Youngstown State Penguins": 2754,
}
